var map = {
	"./stake.gltf": "4cf6",
	"./target pole.gltf": "0ee5",
	"./target.gltf": "047e",
	"./total station tripod.gltf": "098d",
	"./total station.gltf": "3185",
	"./tribrach.gltf": "7a94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4965";